import { gql } from '@apollo/client';

export const QUOTE_CALC_VIEW_MODEL_FRAGMENT = gql`
  fragment QuoteCalcViewModelFields on QuoteCalcViewModel {
    rows {
      key
      parentKey
      isChild
      ownTotal
      type
      rollup {
        rolledTotal
      }
      charge {
        price {
          total
          netPrice
          retailPrice
        }
      }
      equipment {
        price {
          total
          netPrice
          retailPrice
        }
        attachments {
          price {
            total
            netPrice
            retailPrice
          }
        }
      }
      columnTotals {
        total
        markup
        discount
        salesTax
        netPrice
        retailPrice
        wholesalePrice
      }
      breach {
        min
        max
        level
        limit
        bound
        message
        breached
        clamped
        enteredValue
        breakdown {
          total
          ownAmount
          contributions {
            key
            isOwn
            label
            amount
          }
        }
      }
    }
    totals {
      grandTotal
      columnTotals {
        total
        markup
        discount
        salesTax
        netPrice
        retailPrice
        wholesalePrice
      }
      invoice {
        fees
        taxes
        price
      }
      equipment {
        fees
        taxes
        price
      }
      attachments {
        fees
        taxes
        price
      }
    }
    dealer {
      cost
      margin
    }
    profitability {
      marginRate
      grossProfit
      totalDealerCost
      netSellingPrice
      overUnderAllowanceTotal
    }
    netFinanceAmount {
      balanceToFinance
      customerSavings {
        amount
        percent
      }
      deposit
      estimatedMonthlyPayment {
        amount
      }
      fees
      hardCost
      netFinanceAmount
      netTradeIn
      softCost
      taxes
    }
  }
`;
